module.exports = __webpack_public_path__ + "static/media/std_deviation_input.17ecd333.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/std_deviation_input.png
// module id = 2353
// module chunks = 0